<template>
  <div class="d-flex flex-column h-100">
    <div class="d-none d-md-block px-4 py-5 mx-5 my-5 text-center mel-glass-panel">
      <h1 class="display-5 fw-bold text-primary">{{ $t('page.home.heading') }}</h1>
    </div>

    <nav v-if="!isAuthenticated" class="d-block d-md-none flex-grow-1 mel-glass-panel mel-glass-panel-content mel-glass-panel-center container my-2">
      <ul class="nav nav-pills flex-column mb-auto fs-4">
        <li>
          <RouterLink class="nav-link px-2 d-flex flex-column align-items-center" :to="TranslationsService.i18nRoute({ name: 'login' })">
            <font-awesome-layers class="fa-3x">
              <font-awesome-icon :icon="['fas', 'id-card']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('page.login.heading') }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <nav v-else-if="selectedSiteId <= 0" class="d-block d-md-none flex-grow-1 mel-glass-panel mel-glass-panel-content mel-glass-panel-center container my-2">
      <ul class="nav nav-pills flex-column mb-auto fs-4">
        <li>
          <RouterLink class="nav-link px-2 d-flex flex-column align-items-center" :to="TranslationsService.i18nRoute({ name: 'site' })">
            <font-awesome-layers class="fa-3x">
              <font-awesome-icon :icon="['far', 'warehouse']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('page.site.title') }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <nav v-if="isAuthenticated && selectedSiteId > 0" class="d-block d-md-none flex-grow-1 mel-glass-panel mel-glass-panel-content container my-2 sticky-top" style="position: sticky;">
      <ul class="nav nav-pills flex-row mb-auto justify-content-around">
        <li>
          <RouterLink class="nav-link px-2 d-flex flex-column align-items-center" :to="TranslationsService.i18nRoute({ name: 'consumption-create' })">
            <font-awesome-layers class="fa-3x">
              <font-awesome-icon :icon="['far', 'clipboard-medical']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.consumption') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link px-2 d-flex flex-column align-items-center" :to="TranslationsService.i18nRoute({ name: 'order-create' })">
            <font-awesome-layers class="fa-3x">
              <font-awesome-icon :icon="['far', 'cart-shopping']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.orders") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link px-2 d-flex flex-column align-items-center" :to="TranslationsService.i18nRoute({ name: 'stock-issue' })">
            <font-awesome-layers class="fa-3x">
              <font-awesome-icon :icon="['fas', 'minus']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stock-issue") }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>
    <nav v-if="isAuthenticated && selectedSiteId > 0" class="d-block d-md-none flex-grow-1 mel-glass-panel mel-glass-panel-content mel-glass-panel-center container my-2">
      <ul class="nav nav-pills flex-column mb-auto fs-4">
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'consumption-create' })" custom v-slot="{ navigate }">
            <a @click="navigate" :class="['nav-link', { 'active': route.path.includes('/transaction/consumption') }]" href="#">
              <font-awesome-layers class="me-2">
                <font-awesome-icon :icon="['far', 'clipboard-medical']" />
              </font-awesome-layers>
              <span class="ms-1 text">{{ $t('menu.consumption') }}</span>
            </a>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'order-create' })" custom v-slot="{ navigate }">
            <a @click="navigate" :class="['nav-link', { 'active': route.path.includes('/transaction/orders') }]" href="#">
              <font-awesome-layers class="me-2">
                <font-awesome-icon :icon="['far', 'cart-shopping']" />
              </font-awesome-layers>
              <span class="ms-1 text">{{ $t("menu.orders") }}</span>
            </a>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'receivings' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'clipboard-list-check']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.receivings") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'deliveries' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'truck']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.deliveries") }}</span>
          </RouterLink>
        </li>
        <li class="border-top border-secondary-subtle my-3"></li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'stock-receipt' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stock-receipt") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'stock-issue' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['fas', 'minus']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stock-issue") }}</span>
          </RouterLink>
        </li>
        <li class="border-top border-secondary-subtle my-3"></li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'info' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'square-info']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.info-request") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'stocks' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'boxes-stacked']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stocks") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'stock-changes' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['fas', 'plus-minus']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stock-changes") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'stock-demand' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['fas', 'shelves']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.stock-demand") }}</span>
          </RouterLink>
        </li>
        <li class="border-top border-secondary-subtle my-3"></li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'biExpiry' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'hourglass-clock']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.statistics.expiry') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'biItemIssues' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'chart-simple-horizontal']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.statistics.consumption') }}</span>
          </RouterLink>
        </li>
        <li class="border-top border-secondary-subtle my-3"></li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'items' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'rectangle-list']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.items") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'foreign-items' })">
            <font-awesome-layers class="fa-1x me-2">
              <font-awesome-icon :icon="['far', 'rectangle-list']" />
              <font-awesome-icon :icon="['fas', 'person-dolly']" transform="down-8 left-8 shrink-4" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.foreign-items') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'itemblocks' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'kit-medical']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.itemblocks") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'suppliers' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'person-dolly']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.suppliers') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link d-none d-md-block" :to="TranslationsService.i18nRoute({ name: 'labels-item' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'qrcode']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.label-item') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'labels-box' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'tag']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t("menu.label-box") }}</span>
          </RouterLink>
        </li>
        <li class="border-top border-secondary-subtle my-3"></li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'label-printers' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'print']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.label-printers') }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink class="nav-link" :to="TranslationsService.i18nRoute({ name: 'label-templates' })">
            <font-awesome-layers class="me-2">
              <font-awesome-icon :icon="['far', 'file-code']"/>
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('menu.label-templates') }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <FooterComponent />
  </div>
</template>

<script setup lang="ts">
import { RouterLink, useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useAuthStore, useSessionStore } from "@/stores";
import TranslationsService from "@/services/translations.ts";
import FooterComponent from "@/components/FooterComponent.vue";
import { onMounted } from "vue";
import { router } from "@/services";

const route = useRoute();

const authStore = useAuthStore();
const { isAuthenticated } = storeToRefs(authStore);

const sessionStore = useSessionStore();
const { selectedSiteId } = storeToRefs(sessionStore);

onMounted(() => {
  if (!isAuthenticated.value) {
    router.push(TranslationsService.i18nRoute({ name: 'login' }));
  } else if (selectedSiteId.value <= 0) {
    router.push(TranslationsService.i18nRoute({ name: 'site' }));
  }
});
</script>

<style scoped>
.mel-glass-panel-content {
  transition: all 0.4s ease 0s;
  max-width: calc(100% - 40px);
  padding: 1rem;
  position: relative;
}
.mel-glass-panel-content.mel-glass-panel-center {
  left: 50%;
  transform: translate(calc(-50% - 20px), 0);
}
</style>
